import { useBaseStore } from '@/features/common/stores/itemStore';
import { STORE_ID_TYPES, TAKE_OPTIONS } from '@/constants';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getTravelCardOrders, getTravelCards } from '../services/api';
import { TravelCardsDto } from '@/types/webapi';
import { sortByDate, getCardNumberList, mergeTravelCardData } from '@/helpers';
import { useAppConfiguration } from '@/composables';

export const useCardStore = defineStore(STORE_ID_TYPES.TRAVEL_CARD, () => {
    const { language } = useAppConfiguration();
    const base = useBaseStore();
    const isLoading = ref(false);

    const getAllTravelCards = async () => {
        try {
            isLoading.value = true;
            if (base.isUpdated.value) return;

            base.setUpdated(true);

            const { data: travelCardsData } = (await getTravelCards(TAKE_OPTIONS.ALL)) as TravelCardsDto;

            if (travelCardsData?.length) {
                const sortedTravelCards = sortByDate(travelCardsData);
                const travelCardNumbers = getCardNumberList(sortedTravelCards);
                const travelCardOrders = await getTravelCardOrders(travelCardNumbers, language.value);

                // filter out expired travel card products
                const now = Date.now();
                travelCardOrders?.forEach(order => {
                    order.products = order.products.filter(product => !product.validityTime || product.validityTime * 1000 >= now);
                });

                const mergedTravelCardData = mergeTravelCardData(sortedTravelCards, travelCardOrders);

                base.setItems(mergedTravelCardData);
            }
        } catch {
            base.setItems([]);
            base.setUpdated(false);
        } finally {
            isLoading.value = false;
        }
    };

    return {
        ...base,
        isLoading,
        getAllTravelCards
    };
});
